module.exports = __webpack_public_path__ + "static/media/star.02c707b0.svg";